export const AUTHENTICATED_ROUTES = {
  GRIDS: '/grids',
  USERS: '/users',
  GRID: '/g/:gridUuid',
  DEEPL_TEST: '/deepl-test',
}

export const NOT_AUTHENTICATED_ROUTES = {
  LOGIN: '/login',
  // CONTACT: '/contact',
  INVITE_REGISTER: '/invite-register', // invite-register?email=...&related_text=
  RETRIEVE_PASSWORD: '/retrieve-password/:token',
  // AUTOCONNECT: '/autoconnect/:autoconnectUuid',
}

export const ROUTE_PATHS = {
  ...NOT_AUTHENTICATED_ROUTES,
  ...AUTHENTICATED_ROUTES,
}
